<template>
  <el-avatar
    :size="size"
    :src="avatarUrl || null"
    style="background-color: var(--cal-accent-strong); color: var(--cal-text-inverse);"
  >
    <template v-if="!avatarUrl">{{ initials }}</template>
  </el-avatar>
</template>

<script>
export default {
  name: 'EmployeeAvatar',
  props: {
    name: {
      type: String,
      required: true
    },
    avatarUrl: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 34
    }
  },
  computed: {
    initials() {
      const parts = this.name.trim().split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      } else if (parts.length === 1) {
        return parts[0][0].toUpperCase();
      }
      return '';
    }
  }
};
</script>

<style scoped>
/* Никаких дополнительных стилей не требуется */
</style>
